import type { ReactNode } from 'react';
import styles from './SlideFoot.module.css';

interface SlideFootProps {
  left?: ReactNode;
  right?: ReactNode;
}

export default function SlideFoot({ left, right }: SlideFootProps) {
  return (
    <div className={styles.foot}>
      <span>{left}</span>
      <span>{right}</span>
    </div>
  );
}
